function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 20C4.477 20 0 15.522 0 10 0 4.477 4.477 0 10 0s10 4.477 10 10c0 5.522-4.477 10-10 10zm0-18.001A8 8 0 1010.001 18 8 8 0 0010 2zm.052 12.469h-.105a.884.884 0 01-.885-.884v-.012c0-.489.396-.885.885-.885h.105c.489 0 .885.396.885.885v.012a.884.884 0 01-.885.884zm-.038-3.625h-.029a.923.923 0 01-.923-.923V6.392c0-.51.413-.924.923-.924h.029c.51 0 .923.414.923.924V9.92c0 .51-.413.923-.923.923z"
});

var SvgAlert = function SvgAlert(props) {
  return React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgdmlld0JveD0iMCAwIDIwIDIwIj4KICAgIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNMTAgMjBDNC40NzcgMjAgMCAxNS41MjIgMCAxMCAwIDQuNDc3IDQuNDc3IDAgMTAgMHMxMCA0LjQ3NyAxMCAxMGMwIDUuNTIyLTQuNDc3IDEwLTEwIDEwem0wLTE4LjAwMUE4IDggMCAxIDAgMTAuMDAxIDE4IDggOCAwIDAgMCAxMCAyem0uMDUyIDEyLjQ2OWgtLjEwNWEuODg0Ljg4NCAwIDAgMS0uODg1LS44ODR2LS4wMTJjMC0uNDg5LjM5Ni0uODg1Ljg4NS0uODg1aC4xMDVjLjQ4OSAwIC44ODUuMzk2Ljg4NS44ODV2LjAxMmEuODg0Ljg4NCAwIDAgMS0uODg1Ljg4NHptLS4wMzgtMy42MjVoLS4wMjlhLjkyMy45MjMgMCAwIDEtLjkyMy0uOTIzVjYuMzkyYzAtLjUxLjQxMy0uOTI0LjkyMy0uOTI0aC4wMjljLjUxIDAgLjkyMy40MTQuOTIzLjkyNFY5LjkyYzAgLjUxLS40MTMuOTIzLS45MjMuOTIzeiIvPgo8L3N2Zz4K";
export { SvgAlert as ReactComponent };